var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseFundCard',{attrs:{"fundData":_vm.fundData},scopedSlots:_vm._u([{key:"default",fn:function({
		nameTruncated,
		fundStats
	}){return [_c('div',{staticClass:"fund-card",class:_vm.sizeClasses,attrs:{"title":_vm.titleAttribute}},[_c('FundCardHeader',{attrs:{"fundData":_vm.fundData,"name":nameTruncated}}),_vm._v(" "),_c('FundCardStats',{attrs:{"fundStats":fundStats}})],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }